export const NAMESPACE = 'CREATENEWPROJECT'